 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryCargoComdtyFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryCargoComdtyFilterForm"
                            v-model="filtersCargoComdty.id"
                            :label="filtersCargoComdtyLabel.id"
                            :error-messages="errors.collect('id')"
                            data-vv-name="id"
                            :data-vv-as="filtersCargoComdtyLabel.id"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearCargoComdtyFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doCargoComdtyFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="cargoComdtyHeaders"
          :items="cargoComdtyItems"
          v-bind:options.sync="paginationCargoComdty"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsCargoComdty"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.comdty }}</td>
              <td>{{ row.item.comdtyDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignCargoComdty(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersCargoComdtyLabel: {
        id: 'Goods'
      },
      filtersCargoComdty: {
        id: undefined,
        comdty: undefined,
        comdtyDesc: undefined
      },
      cargoComdtyItems: [],
      totalItemsCargoComdty: 0,
      cargoComdtyHeaders: [
        { text: 'Goods', align: 'left', value: 'comdty' },
        { text: 'Description', value: 'comdtyDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationCargoComdty: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearCargoComdtyFilters()
  },
  methods: {
    closeDialog() {
      this.resetFilterForm()
      this.$emit('close')
    },
    doClearCargoComdtyFilters() {
      this.resetFilterForm()
      this.fetchCargoComdtyData()
    },
    doCargoComdtyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryCargoComdtyFilterForm').then((result) => {
        if (result) {
          this.paginationCargoComdty.page = 1
          this.fetchCargoComdtyData()
        }
      })
    },
    resetFilterForm() {
      this.filtersCargoComdty.id = ''
      this.filtersCargoComdty.comdty = ''
      this.filtersCargoComdty.comdtyDesc = ''
    },
    assignCargoComdty(data) {
      this.$emit('assign-cargo-comdty-val-info', data)
      this.$emit('close')
    }
  },
  computed: {},
  watch: {
    'paginationCargoComdty': function (value) {
      this.fetchCargoComdtyData()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin],
  props: {
    title: {
      type: String,
      default: 'Cargo Comdty'
    }
  }
}
</script>
